import { Link } from 'react-router-dom';
import { Logo } from './Logo';

export default function Footer() {
  const footerLinks = [
    {
      title: 'Product',
      links: [
        { label: 'Features', href: '#features' },
        { label: 'Pricing', href: '#pricing' },
      ],
    },
    {
      title: 'Company',
      links: [{ label: 'Contact', href: 'mailto:hello@adastronaut.com' }],
    },
  ];

  return (
    <footer className="bg-dark">
      <div className="w-full px-6 md:px-10 lg:px-16 py-16 md:py-20">
        {/* Top Row */}
        <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-12 mb-16">
          {/* Brand */}
          <div className="lg:max-w-sm">
            <div className="flex items-center mb-4">
              <Logo height={66} className="brightness-0 invert" />
            </div>
            <p className="text-white/40 text-sm leading-relaxed">
              AI-powered social media post creation. Turn your products into stunning content in seconds.
            </p>
          </div>

          {/* Links */}
          <div className="grid grid-cols-2 gap-8 lg:gap-12">
            {footerLinks.map((group) => (
              <div key={group.title}>
                <h4 className="text-sm font-display font-bold text-white/80 mb-4">{group.title}</h4>
                <ul className="space-y-3">
                  {group.links.map((link) => (
                    <li key={link.label}>
                      <a
                        href={link.href}
                        className="text-sm text-white/40 hover:text-white transition-colors"
                      >
                        {link.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        {/* Bottom */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 pt-8 border-t border-white/10">
          <div className="flex flex-col sm:flex-row items-center gap-2 sm:gap-4">
            <p className="text-sm text-white/30">
              &copy; 2026 Ad Astronaut. All rights reserved.
            </p>
            <Link
              to="/privacy"
              className="text-sm text-white/40 hover:text-white transition-colors"
            >
              Privacy Policy
            </Link>
            <Link
              to="/terms"
              className="text-sm text-white/40 hover:text-white transition-colors"
            >
              Terms of Service
            </Link>
            <Link
              to="/data-deletion"
              className="text-sm text-white/40 hover:text-white transition-colors"
            >
              Data Deletion
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
